import React from 'react';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const FORMSUBMIT_ENDPOINT = 'https://formsubmit.co/ajax/maca.castrob@gmail.com';

export default function Block7CTA() {
  const [formState, setFormState] = React.useState('idle'); // idle | submitting | success
  const [error, setError] = React.useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const form = e.currentTarget;
    const formData = new FormData(form);
    const name = String(formData.get('name') || '').trim();
    const institution = String(formData.get('institution') || '').trim();
    const email = String(formData.get('email') || '').trim();

    if (!name || !institution || !email) {
      setError('Por favor complete los tres campos antes de enviar.');
      return;
    }

    if (!EMAIL_REGEX.test(email)) {
      setError('Por favor ingresa un correo electrónico válido.');
      return;
    }

    setFormState('submitting');

    const message =
      `Usuario ${name}, de Red / CESFAM / Municipio ${institution} ha pedido, a través de la página de YoMeControlo, contacto con el email ${email}`;

    try {
      // FormSubmit rejects posts without a Referer; Azure SWA can strip it without this.
      const payload = {
        _subject: 'Nuevo contacto institucional - Yo Me Controlo',
        _captcha: 'false',
        _url: window.location.href,
        Nombre: name,
        Institucion: institution,
        email,
        message,
      };

      const response = await fetch(FORMSUBMIT_ENDPOINT, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
        referrerPolicy: 'strict-origin-when-cross-origin',
      });

      const result = await response.json();

      if (response.ok && (result.success === 'true' || result.success === true)) {
        setFormState('success');
      } else {
        setFormState('idle');
        setError(
          result?.message ||
            'Ocurrió un error al enviar el formulario. Por favor, escribe a contacto@yomecontrolo.cl.'
        );
      }
    } catch (err) {
      console.error(err);
      setFormState('idle');
      setError(
        'No se pudo conectar con el servidor. Por favor, escribe a contacto@yomecontrolo.cl.'
      );
    }
  };

  return (
    <section className="py-16 md:py-24 px-6 md:px-16 bg-paper" id="contacto">
      <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row gap-16 lg:gap-24 items-center">
        <div className="w-full lg:w-1/2 text-left">
          <div className="text-[14px] font-semibold text-ink-soft/70 mb-6">
            Iniciar conversación
          </div>
          <h2 className="text-[32px] md:text-[40px] lg:text-[48px] font-bold text-ink mb-8 tracking-tight leading-[1.1]">
            La información ya existe. El desafío es lograr que se convierta en cuidado.
          </h2>
          <p className="text-[16px] md:text-[18px] text-ink-soft leading-[1.6] mb-12 max-w-lg">
            YMC-BAC ayuda a las redes de Atención Primaria a encontrar quién necesita una acción, hacer que esa acción ocurra y mantener la trayectoria en movimiento.
          </p>
        </div>
        <div className="w-full lg:w-1/2 max-w-lg">
          <div className="bg-paper border border-line rounded-xl p-8 md:p-10 text-ink shadow-sm relative overflow-hidden">
            <h3 className="text-[20px] font-bold text-ink mb-8 text-center">
              Conversemos sobre tu red
            </h3>
            {formState === 'success' ? (
              <div className="flex flex-col items-center justify-center py-10 text-center">
                <div className="w-16 h-16 rounded-full bg-brand/10 flex items-center justify-center text-brand mb-6">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                </div>
                <h4 className="text-[20px] font-bold text-ink mb-4">Mensaje recibido</h4>
                <p className="text-[14px] text-ink-soft">Nos contactaremos contigo a la brevedad para conocer más sobre las necesidades de tu red.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="flex flex-col gap-5" noValidate>
                <div className="flex flex-col gap-2">
                  <label htmlFor="name" className="text-[13px] font-medium text-ink">Nombre y Apellido</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    className="border border-line rounded-xl p-3 text-[14px] outline-none focus:border-brand bg-surface transition-colors"
                    placeholder="Tu nombre"
                  />
                </div>
                <div className="flex flex-col gap-2">
                  <label htmlFor="institution" className="text-[13px] font-medium text-ink">Red / CESFAM / Municipio</label>
                  <input
                    type="text"
                    id="institution"
                    name="institution"
                    required
                    className="border border-line rounded-xl p-3 text-[14px] outline-none focus:border-brand bg-surface transition-colors"
                    placeholder="Institución"
                  />
                </div>
                <div className="flex flex-col gap-2">
                  <label htmlFor="email" className="text-[13px] font-medium text-ink">Correo Institucional</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="border border-line rounded-xl p-3 text-[14px] outline-none focus:border-brand bg-surface transition-colors"
                    placeholder="tu@institucion.cl"
                  />
                </div>

                {error ? (
                  <p className="text-[13px] text-red-600 bg-red-50 border border-red-100 rounded-xl px-3 py-2">
                    {error}
                  </p>
                ) : null}

                <button
                  type="submit"
                  disabled={formState === 'submitting'}
                  className="mt-4 bg-brand text-white px-8 py-4 text-[14px] font-semibold rounded-xl hover:bg-opacity-90 transition-colors w-full focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  {formState === 'submitting' ? 'ENVIANDO...' : 'SOLICITAR CONTACTO'}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
